import { css } from '@emotion/core'
import { colors, spacing } from 'styles/variables'
import { buttonVariations, buttonSizes } from './variations'

const activeGreen = colors.greens.green7
const disabledGreen = colors.greens.green8

export default {
  btn: css`
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all 0.3 ease;
    border-radius: ${spacing(3.75)};
    padding: ${spacing(1.25, 4.5)};
    box-sizing: border-box;
  `,
  [buttonVariations.PRIMARY]: css`
    background-color: ${activeGreen};
    border: none;

    :disabled {
      background-color: ${disabledGreen};
    }
  `,
  [buttonVariations.SECONDARY]: css`
    background-color: transparent;
    border: 1px solid ${activeGreen};
    color: ${activeGreen};

    :disabled {
      border: 1px solid ${disabledGreen};
      color: ${disabledGreen};
    }
  `,
  [buttonVariations.PLAIN]: css`
    background-color: transparent;
    border: transparent;
    color: ${activeGreen};
    padding: 0;
  `,
  [buttonSizes.SMALL]: css`
    height: ${spacing(5)};
    padding: ${spacing(1, 2.5)};
  `,
  [buttonSizes.MEDIUM]: css`
    height: ${spacing(6)};
    padding: ${spacing(1, 3.5)};
  `,
  [buttonSizes.LARGE]: css`
    height: ${spacing(7)};
  `,
  loader: css`
    transform: scale(0.5);
    white-space: nowrap;
  `,
}
